export type Percentage = "%";
export type Pixel = "px";
export type FontSize = "em";
export type ViewportWidth = "vw";
export type ViewportHeight = "vh";

export type CSSUnitType = 
  Percentage |
  Pixel |
  FontSize |
  ViewportWidth |
  ViewportHeight 
;

export abstract class CSSUnitValue<CSSUnitType>
{ 
  readonly type:CSSUnitType;
  private _value:number;

  constructor( type:CSSUnitType, value:number )
  {
    this.type = type;
    this._value = value;
  }

  toString()
  {
    return this._value + ( "" + this.type );
  }

  get value()
  {
    return this._value;
  }

  
}

export class PercentageValue extends CSSUnitValue<Percentage>
{
  static readonly unit:Percentage = "%";

  constructor( value:number )
  {
    super( PercentageValue.unit, value );
  }
}

export class PixelValue extends CSSUnitValue<Pixel>
{
  static readonly unit:Pixel = "px";

  constructor( value:number )
  {
    super( PixelValue.unit, value );
  }
}

export class FontSizeValue extends CSSUnitValue<FontSize>
{
  static readonly unit:FontSize = "em";
  
  constructor( value:number )
  {
    super( FontSizeValue.unit, value );
  }
}

export class ViewportWidthValue extends CSSUnitValue<ViewportWidth>
{
  static readonly unit:ViewportWidth = "vw";
  
  constructor( value:number )
  {
    super( ViewportWidthValue.unit, value );
  }
}

export class ViewportHeightValue extends CSSUnitValue<ViewportHeight>
{
  static readonly unit:ViewportHeight = "vh";
  
  constructor( value:number )
  {
    super( ViewportHeightValue.unit, value );
  }

  
}

export type CSSLength = 
  PercentageValue |
  PixelValue |
  FontSizeValue |
  ViewportWidthValue |
  ViewportHeightValue;